import _extends from "@babel/runtime-corejs2/helpers/extends";
import React, { Fragment } from 'react';
import classNames from 'classnames';
import CompactNav from './CompactNav';
import Logo from './Logo';
import { ContextConsumer } from './Context';
import { DefaultLinkWrapper } from './NavItem';

var Header = function Header(props) {
  var _props$LinkWrapper = props.LinkWrapper,
      LinkWrapper = _props$LinkWrapper === void 0 ? DefaultLinkWrapper : _props$LinkWrapper;
  return /*#__PURE__*/React.createElement(Fragment, null, props.banner, /*#__PURE__*/React.createElement("div", {
    className: classNames('cloud-ui-nav-chrome header', {
      'search-active': props.searchActive
    }),
    ref: props.forwardedRef
  }, /*#__PURE__*/React.createElement(CompactNav, {
    inverted: props.inverted
  }), /*#__PURE__*/React.createElement(LinkWrapper, {
    href: "/",
    className: "cloud-ui-nav-logo-link"
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: "cloud-ui-nav horizontal"
  }, props.children)));
};

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var LinkWrapper = _ref.LinkWrapper,
        searchActive = _ref.searchActive,
        banner = _ref.banner;
    return /*#__PURE__*/React.createElement(Header, _extends({}, props, {
      LinkWrapper: LinkWrapper,
      searchActive: searchActive,
      forwardedRef: ref,
      banner: banner
    }));
  });
});